<template>
  <div>

    <gg-card>
      <gg-card-header>
        Show You're Making a Difference with GreenGeeks Seals
      </gg-card-header>
      <gg-card-text class="pa-4">
        <p>
          Show off to your visitors that your website is making a difference
          by hosting on environmentally friendly hosting. Visitors will be able
          to verify that you host green by clicking on the GreenGeeks Seal.
        </p>
        <v-row class="text-center">
          <v-col v-for="n in 26" :key="`Green${n}`" cols="6" sm="4" md="3" lg="2">
            <div class="tag-cnt">
            <div class="tag-img">
              <img
                :src="`${tag_image_name}${n}.png`"
                :alt="`GreenGeeks Seal ${n}`"
              >
            </div>
            <div class="tag-btn">
              <gg-btn

                tile elevation="0"
                dark
                @click="switchModalState(n)">
                Get Code
                <span class="visually-hidden text-lowercase">button</span>
              </gg-btn>
            </div>
            </div>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>
    <template>
      <gg-modal :is-active="modal" @close="modal = false">
        <template v-slot:toolbar>
          GreenGeeks seal tag
        </template>
        <template v-slot:body>
          <p>
            This is the tag you will place on your website to display your
            GreenGeeks Seal. When visitors click on the link, it will open a
            new window which verifies that your website is hosted on environmentally
            friendly servers by GreenGeeks.
          </p>
          <v-textarea
            label="Code"
            outlined
            :value="codeblock"
            rows="8"
            :readonly="true"
          ></v-textarea>
        </template>
        <template v-slot:actions>
          <gg-btn primary @click="switchModalState">
            Close
            <span class="visually-hidden text-lowercase">button</span>
          </gg-btn>
        </template>
      </gg-modal>
    </template>
  </div>
</template>

<script>

export default {
  name: 'GGSeal',
  data: () => ({
    tag_image_name: 'https://static.greengeeks.com/ggseal/Green_',
    modal: false,
    tagnumber: 0,
    tag_imghtml: '',
    codeblock: '',
  }),
  methods: {
    switchModalState (tagnumber) {
      this.modal = !this.modal
      this.tagnumber = tagnumber
      this.tag_imghtml = '<img src="https://static.greengeeks.com/ggseal/Green_' + tagnumber + '.png">'
      // Funny indention needed so codeblock looks good on UI. Code can't be a <button> or it will render as a button in browser. It should just be an image.
      this.codeblock =
      `<!-- GreenGeeks Seal Code -->
<div><a href="#" onclick="ggs_ggseal()"><img src="${this.tag_image_name}` + tagnumber + `.png"></a><script>function ggs_ggseal(){window.open("https://my.greengeeks.com/seal/","_blank")}</scr` + `ipt></div>
<!-- End GreenGeeks Seal Code -->`
    }
  }
}
</script>

<style lang="scss" scoped>
  .tag-cnt {
    .tag-img {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 150px;
      padding-bottom: 20px;
    }
    .tag-btn {
      padding-bottom: 20px;
    }
  }
</style>
